@use 'src/globals/main';

pn-ocr-search {
  .bold {
    font-weight: 700;
  }

  .search-results,
  .error-text-container {
    padding: 1em 0.5em;
  }

  .invalid-text-container {
    padding: 0.5em 1em;

    .invalid-ocr {
      color: main.$warning;
    }
  }
}
